import { useEffect } from "react";
import { useState } from "react";
import MeetupsControl from "../../../components/Meetups/MeetupsControl";
import MeetupsTable from "../../../components/Meetups/MeetupsTable";
import MeetupsAddForm from "../../../components/Meetups/MeetupsAddForm/MeetupsAddForm";
import { Activity, MeetupsState, MeetupsTableItemType } from "../../../types";
import AddFormBtns from "../../../components/Meetups/MeetupsAddForm/AddFormBtns";
import { meetupsTableItems as initialMeetups, meetupsExcel } from "../../../misc/constants";
import { useGlobalMiscState } from "../../../stores/misc";
import { useHookstate } from "@hookstate/core";
import { exportToExcel, userHasRole, getDateOnly, updateMiscState } from "../../../misc/utils";
import MeetupsAdmin from "../../../components/Meetups/MeetupsAdmin/MeetupsAdmin";
import { useUniversalFind } from "../../../hooks/universal";
import { useGlobalUserState } from "../../../stores/user";
import MeetupsCommentModal from "../../../components/Meetups/MeetupsCommentModal/MeetupsCommentModal";
type Props = {
  display: string;
};

export default function Meetups({ display }: Props) {
  const userState = useGlobalUserState();
  const user = userState.get();
  const miscState = useGlobalMiscState();
  const activitiesTriggerFetch = miscState.get('activitiesTriggerFetch') || 0;
  const isAddFormOpen = Boolean(miscState.get('isMeetupsAddFormOpen'))
  const isCommentModalOpen = Boolean(miscState.get('isMeetupsCommentModalOpen'))
  const currentMeetupForComment: Activity | null = miscState.get('meetupsFormEditItem') || null;
  const localState = useHookstate<MeetupsState>({} as MeetupsState);
  const state = localState.get();
  const { selectedDepartmentId, selectedCategoryId, selectedStatus, search, selectedItem, fromDate, toDate } = state;
  const [newMeetup, setNewMeetup] = useState<MeetupsTableItemType | null>(null);
  const allActivites: Activity[] = useUniversalFind('Activity', {}, {
    include: ['category', 'department', 'target_audience'],
    order: [['start_date', 'DESC']]
  }, activitiesTriggerFetch, undefined, true);

  const setIsAddFormOpen = (value: boolean) => {
    miscState.set('isMeetupsAddFormOpen', value)
  }

  useEffect(() => {
    miscState.set('meetupsFormEditItem', {})
  }, [])

  const [currentMeet, setCurrentMeet] = useState<MeetupsTableItemType | null>(
    null
  );

  useEffect(() => {
    currentMeet ? setIsAddFormOpen(true) : setIsAddFormOpen(false);
  }, [currentMeet]);

  const onAddFormClose = () => {
    setIsAddFormOpen(false)
    localState.selectedItem.set(null)
    miscState.set('meetupsFormEditItem', null);
  }

  const activities = allActivites.filter((c) => {
    let retValue = true;
    if (selectedCategoryId?.length) {
      retValue = retValue && c.category_id === parseInt(selectedCategoryId)
    }

    if (selectedDepartmentId?.length) {
      retValue = retValue && c.department_id === parseInt(selectedDepartmentId)
    }

    if (fromDate) {
      retValue = retValue && new Date(c.start_date) >= new Date(fromDate)
    }

    if (toDate) {
      retValue = retValue && new Date(c.start_date) <= new Date(toDate)
    }

    if (selectedStatus?.length) {
      retValue = retValue && c.status === parseInt(selectedStatus)
    }

    if (search?.length) {
      retValue = retValue && (c.name.toLowerCase().includes(search.toLowerCase()) || c.description.toLowerCase().includes(search.toLowerCase()))
    }

    if (display === "decide") {
      retValue = retValue && c.status === 0;
    }

    if (!userHasRole('view_activities_extended')) {
      retValue = retValue && c.created_by === user.id
    }

    return retValue;
  }).slice()

  const onExport = () => {
    exportToExcel(`activities_${(fromDate && toDate) ? `${getDateOnly(fromDate).replaceAll('.', '_')}-${getDateOnly(toDate).replaceAll('.', '_')}` : 'all'}_report`, activities, meetupsExcel)()
  }

  return (
    <div className="flex flex-col lg:flex-row gap-3 sm:gap-4 h-full overflow-hidden">
      <div className={`bg-white rounded-xl shadow-sm ${isAddFormOpen ? 'lg:flex-[38]' : 'w-full'} flex flex-col overflow-hidden`}>
        <div className="flex flex-col overflow-y-auto flex-1 min-h-0 w-full">
          <div className="p-3 sm:p-4 md:p-5 w-full">
            <MeetupsControl
              localState={localState}
              setIsAddFormOpen={setIsAddFormOpen}
              isAddFormOpen={isAddFormOpen}
              onExport={onExport}
            />
          </div>
          <div className="flex-1 overflow-y-auto w-full">
            <MeetupsTable
              display={display}
              localState={localState}
              isAddFormOpen={isAddFormOpen}
            />
          </div>
        </div>
      </div>
      {isAddFormOpen && (
        <div className="flex flex-col w-full gap-3 lg:flex-[62] overflow-hidden">
          <div className="bg-white rounded-xl shadow-sm p-3 sm:p-4 md:p-6 overflow-y-auto flex-1 min-h-0">
            <MeetupsAddForm
              onClose={onAddFormClose}
            />
          </div>
        </div>
      )}
      {isCommentModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={() => miscState.set('isMeetupsCommentModalOpen', false)}>
          <MeetupsCommentModal
            currentMeetup={currentMeetupForComment}
            setIsCommentModalOpen={(value: boolean) => miscState.set('isMeetupsCommentModalOpen', value)}
          />
        </div>
      )}
    </div>
  );
}
